import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import {Quote} from "../types/Quote";

export const useGetEstimate = (quoteId: string) => {
    const { data, isLoading } = useQuery({
        queryKey: ['ee-tool-get-estimate', quoteId],
        queryFn: async () => await apiClient.get('ee-tool/get-estimate?quoteId=' + quoteId) as Quote,
        staleTime: 5 * 60 * 1000,
        enabled: (quoteId !== '0')
    });

    return {
        data: data || undefined,
        isLoading: isLoading
    };
};
